import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Input, Label, FormGroup, Button } from "reactstrap";
import { useDispatch } from "react-redux";

const AddOrganization = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    password: "",
    plainPassword: "",
    slug: "",
    thumbnail: "",
    description: "",
    status: 1,
  });
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    AuthReducer: { auth }
  } = useSelector((state) => state);


  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "thumbnail") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    }
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = () => {
    const form = new FormData();
    form.append('name', formData.name)
    form.append('email', formData.email)
    form.append('mobile', formData.mobile)
    form.append('password', formData.password)
    form.append('plainPassword', formData.plainPassword)
    form.append('description', formData.description)
    form.append("status", formData.status)
    axios
      .post(`/api/admin/v1/add-organization`, form, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data?.message);
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err.response.data);
        setErrors(err.response.data.data);
      });
  };

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h5 className="text-white">Add Organization</h5>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Name<span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.name}
                name="name"
                invalid={errors?.name}
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.name} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Email<span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.email}
                name="email"
                invalid={errors?.email}
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.email} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Mobile<span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.mobile}
                name="mobile"
                invalid={errors?.mobile}
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.mobile} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Password<span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.password}
                name="password"
                invalid={errors?.password}
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.password} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Confirm Password<span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.plainPassword}
                name="plainPassword"
                invalid={errors?.plainPassword}
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.plainPassword} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Upload Picture</Label>
              <Input type="file" name="thumbnail" onChange={(e) => setFormData(prev => ({ ...prev, thumbnail: e.target.files[0] }))} />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Description</Label>
              <Input
                value={formData?.description}
                name="description"
                type="textarea"
                onChange={inputHandler}
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={formData?.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOrganization;
